import { createAction, props } from '@ngrx/store';
import { IExpenses } from 'src/app/shared/interfaces/expenses/iexpenses';

enum ExpensesActionType {
  LOAD_EXPENSES = '[expenses] load expenses from api',
  LOAD_EXPENSES_SUCCESS = '[expenses] load expenses from api return success',
  LOAD_EXPENSES_ERROR = '[expenses] load expenses from api return error',
  SAVE_EXPENSES = '[expenses] save expenses from api',
  SAVE_EXPENSES_SUCCESS = '[expenses] edit expenses from api return success',
  EDIT_EXPENSES = '[expenses] edit expenses from api',
  EDIT_EXPENSES_SUCCESS = '[expenses] edit expenses from api return success',
  DELETE_EXPENSES = '[expenses] delete expenses from api',
}

export const loadExpenses = createAction(ExpensesActionType.LOAD_EXPENSES);
export const loadExpensesSuccess = createAction(
  ExpensesActionType.LOAD_EXPENSES_SUCCESS,
  props<{ lista: IExpenses[] }>()
);
//vai para o effects
export const saveExpenses = createAction(
  ExpensesActionType.SAVE_EXPENSES,
  props<{ expenses: IExpenses }>()
);
//vai para o reducer
export const saveExpensesSuccess = createAction(
  ExpensesActionType.SAVE_EXPENSES_SUCCESS,
  props<{ expenses: IExpenses }>()
);
//vai para o effects
export const editExpenses = createAction(
  ExpensesActionType.EDIT_EXPENSES,
  props<{ expenses: IExpenses; id: number }>()
);
//vai para o reducer
export const editExpensesSuccess = createAction(
  ExpensesActionType.EDIT_EXPENSES_SUCCESS,
  props<{ expenses: IExpenses }>()
);

export const deleteExpenses = createAction(
  ExpensesActionType.DELETE_EXPENSES,
  props<{ id: number }>()
);
